import {
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    EDIT_LANGUAGE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove, update } from "firebase/database";
import { getLangKey } from "../other/getLangKey";

export const fetchLanguages = () => (dispatch) => {

    console.log("fetchLanguages action called, firebase available:", !!firebase);
    console.log("firebase database:", !!firebase.database);
    console.log("languagesRef:", !!firebase.languagesRef);

    const {
        languagesRef
    } = firebase;

    // Check if database is available
    if (!languagesRef) {
        console.warn("Database not available, using default language");
        // Provide complete French and English languages to allow app to continue
        const defaultLanguages = {
            "lang1": {
                "langLocale": "fr",
                "langName": "Français",
                "default": true,
                "dateLocale": "fr",
                "keyValuePairs": {
                    "loading": "Chargement...",
                    "login": "Connexion",
                    "signIn": "Se Connecter",
                    "email": "Email",
                    "password": "Mot de passe",
                    "submit": "Soumettre",
                    "cancel": "Annuler",
                    "ok": "OK",
                    "alert": "Alerte",
                    "error": "Erreur",
                    "success": "Succès",
                    "auth_error": "Erreur d'Authentification: Veuillez vérifier vos identifiants",
                    "login_error": "Erreur d'authentification",
                    "proper_email": "Veuillez saisir l'email correctement.",
                    "request_otp": "Se Connecter Avec OTP",
                    "password_blank_messege": "le mot de passe ne doit pas être vide",
                    "not_logged_in": "Non connecté",
                    "select_country": "Sélectionner le pays",
                    "contact_placeholder": "Email ou Numéro de téléphone",
                    "email_id": "Adresse Email",
                    "mobile_number": "Numéro de téléphone",
                    "otp_here": "OTP ici",
                    "lang1": "🇫🇷 FR",
                    "create_new_user": "Créer un nouvel utilisateur",
                    "in_demo_mobile_login": "Dans la démo, la connexion mobile",
                    "email_or_mobile_issue": "Problème d'email ou de mobile",
                    "mobile_no_blank_error": "Erreur numéro mobile vide",
                    "contact_input_error": "Erreur de saisie de contact",
                    "country_blank_error": "Erreur pays vide",
                    "otp_blank_error": "Erreur OTP vide",
                    "apple_signin_error": "Apple SignIn n'est pas configuré ou vous avez déjà utilisé le même email",
                    "set_link_email": "Définir un email de liaison",
                    "verify_otp": "Vérifier OTP",
                    "forgot_password": "Mot de passe oublié",
                    "spacer_message": "OU",
                    "register_as_driver": "S'inscrire comme chauffeur",
                    "terms": "Conditions d'utilisation",
                    "select_language": "Sélectionner la Langue"
                }
            },
            "lang2": {
                "langLocale": "en",
                "langName": "English",
                "default": false,
                "dateLocale": "en",
                "keyValuePairs": {
                    "loading": "Loading...",
                    "login": "Login",
                    "signIn": "SignIn",
                    "email": "Email",
                    "password": "Password",
                    "submit": "Submit",
                    "cancel": "Cancel",
                    "ok": "OK",
                    "alert": "Alert",
                    "error": "Error",
                    "success": "Success",
                    "auth_error": "Auth Error: Please check your entered credentials",
                    "login_error": "Authentication error",
                    "proper_email": "Please enter email properly.",
                    "request_otp": "Sign In With OTP",
                    "password_blank_messege": "password not blank",
                    "not_logged_in": "Not logged in",
                    "select_country": "Select Country",
                    "contact_placeholder": "Email or Phone Number",
                    "email_id": "Email Address",
                    "mobile_number": "Phone Number",
                    "otp_here": "OTP here",
                    "lang1": "🇬🇧 EN",
                    "create_new_user": "Create new user",
                    "in_demo_mobile_login": "In demo mobile login",
                    "email_or_mobile_issue": "Email or mobile issue",
                    "mobile_no_blank_error": "Mobile number blank error",
                    "contact_input_error": "Contact input error",
                    "country_blank_error": "Country blank error",
                    "otp_blank_error": "OTP blank error",
                    "apple_signin_error": "Apple SignIn is not set up or you have used the same email already",
                    "set_link_email": "Set link email",
                    "verify_otp": "Verify OTP",
                    "forgot_password": "Forgot Password",
                    "spacer_message": "OR",
                    "register_as_driver": "Register",
                    "terms": "Terms & Conditions",
                    "user_exists": "User already exists",
                    "reg_error": "Registration error",
                    "referer_not_found": "Referrer not found",
                    "referral_email_used": "Referral email already used",
                    "referral_number_used": "Referral number already used",
                    "registration_title": "Registration",
                    "first_name_placeholder": "First Name",
                    "last_name_placeholder": "Last Name",
                    "email_placeholder": "Email Address",
                    "mobile": "Mobile",
                    "confirm_password": "Confirm Password",
                    "referral_id_placeholder": "Referral ID (optional)",
                    "register_button": "Register",
                    "customer": "Customer",
                    "driver": "Driver",
                    "confirm_password_not_match_err": "Passwords do not match",
                    "password_must_not_contain_whitespaces": "Password must not contain whitespaces",
                    "password_must_have_at_least_one_uppercase_character": "Password must have at least one uppercase character",
                    "password_must_have_at_least_one_lowercase_character": "Password must have at least one lowercase character",
                    "password_must_contain_at_least_one_digit": "Password must contain at least one digit",
                    "proper_input_name": "Please enter a valid name",
                    "select_language": "Select Language"
                }
            }
        };
        
        console.log("Dispatching default languages:", defaultLanguages);
        dispatch({
            type: FETCH_LANGUAGE_SUCCESS,
            payload: defaultLanguages
        });
        return;
    }

    dispatch({
        type: FETCH_LANGUAGE,
        payload: null
    });
    
    console.log("Languages: Setting up onValue listener...");
    
    // Set a timeout to provide default languages if Firebase doesn't respond
    const timeoutId = setTimeout(() => {
        console.log("Languages: Firebase listener timeout, using default languages");
        const defaultLanguages = [
            {
                "id": "lang1",
                "langLocale": "fr",
                "langName": "Français",
                "default": true,
                "dateLocale": "fr",
                "keyValuePairs": {
                    "loading": "Chargement...",
                    "login": "Connexion",
                    "signIn": "Se Connecter",
                    "email": "Email",
                    "password": "Mot de passe",
                    "submit": "Soumettre",
                    "cancel": "Annuler",
                    "ok": "OK",
                    "alert": "Alerte",
                    "error": "Erreur",
                    "success": "Succès",
                    "auth_error": "Erreur d'Authentification: Veuillez vérifier vos identifiants",
                    "login_error": "Erreur d'authentification",
                    "proper_email": "Veuillez saisir l'email correctement.",
                    "request_otp": "Se Connecter Avec OTP",
                    "password_blank_messege": "le mot de passe ne doit pas être vide",
                    "not_logged_in": "Non connecté",
                    "select_country": "Sélectionner le pays",
                    "contact_placeholder": "Email ou Numéro de téléphone",
                    "email_id": "Adresse Email",
                    "mobile_number": "Numéro de téléphone",
                    "otp_here": "OTP ici",
                    "lang1": "🇫🇷 FR",
                    "create_new_user": "Créer un nouvel utilisateur",
                    "in_demo_mobile_login": "Dans la démo, la connexion mobile",
                    "email_or_mobile_issue": "Problème d'email ou de mobile",
                    "mobile_no_blank_error": "Erreur numéro mobile vide",
                    "contact_input_error": "Erreur de saisie de contact",
                    "country_blank_error": "Erreur pays vide",
                    "otp_blank_error": "Erreur OTP vide",
                    "apple_signin_error": "Apple SignIn n'est pas configuré ou vous avez déjà utilisé le même email",
                    "set_link_email": "Définir un email de liaison",
                    "verify_otp": "Vérifier OTP",
                    "forgot_password": "Mot de passe oublié",
                    "spacer_message": "OU",
                    "register_as_driver": "S'inscrire",
                    "terms": "Conditions d'utilisation",
                    "user_exists": "L'utilisateur existe déjà",
                    "reg_error": "Erreur d'inscription",
                    "referer_not_found": "Parrain non trouvé",
                    "referral_email_used": "Email de parrainage déjà utilisé",
                    "referral_number_used": "Numéro de parrainage déjà utilisé",
                    "registration_title": "Inscription",
                    "first_name_placeholder": "Prénom",
                    "last_name_placeholder": "Nom",
                    "email_placeholder": "Adresse email",
                    "mobile": "Mobile",
                    "confirm_password": "Confirmer le mot de passe",
                    "referral_id_placeholder": "ID de parrainage (optionnel)",
                    "register_button": "S'inscrire",
                    "customer": "Client",
                    "driver": "Chauffeur",
                    "confirm_password_not_match_err": "Les mots de passe ne correspondent pas",
                    "password_must_not_contain_whitespaces": "Le mot de passe ne doit pas contenir d'espaces",
                    "password_must_have_at_least_one_uppercase_character": "Le mot de passe doit contenir au moins une majuscule",
                    "password_must_have_at_least_one_lowercase_character": "Le mot de passe doit contenir au moins une minuscule",
                    "password_must_contain_at_least_one_digit": "Le mot de passe doit contenir au moins un chiffre",
                    "proper_input_name": "Veuillez saisir un nom valide",
                    "select_language": "Sélectionner la Langue"
                }
            },
            {
                "id": "lang2", 
                "langLocale": "en",
                "langName": "English",
                "default": false,
                "dateLocale": "en",
                "keyValuePairs": {
                    "loading": "Loading...",
                    "login": "Login",
                    "signIn": "SignIn",
                    "email": "Email",
                    "password": "Password",
                    "submit": "Submit",
                    "cancel": "Cancel",
                    "ok": "OK",
                    "alert": "Alert",
                    "error": "Error",
                    "success": "Success",
                    "auth_error": "Auth Error: Please check your entered credentials",
                    "login_error": "Authentication error",
                    "proper_email": "Please enter email properly.",
                    "request_otp": "Sign In With OTP",
                    "password_blank_messege": "password not blank",
                    "not_logged_in": "Not logged in",
                    "select_country": "Select Country",
                    "contact_placeholder": "Email or Phone Number",
                    "email_id": "Email Address",
                    "mobile_number": "Phone Number",
                    "otp_here": "OTP here",
                    "lang1": "🇬🇧 EN",
                    "create_new_user": "Create new user",
                    "in_demo_mobile_login": "In demo mobile login",
                    "email_or_mobile_issue": "Email or mobile issue",
                    "mobile_no_blank_error": "Mobile number blank error",
                    "contact_input_error": "Contact input error",
                    "country_blank_error": "Country blank error",
                    "otp_blank_error": "OTP blank error",
                    "apple_signin_error": "Apple SignIn is not set up or you have used the same email already",
                    "set_link_email": "Set link email",
                    "verify_otp": "Verify OTP",
                    "forgot_password": "Forgot Password",
                    "spacer_message": "OR",
                    "register_as_driver": "Register",
                    "terms": "Terms & Conditions",
                    "user_exists": "User already exists",
                    "reg_error": "Registration error",
                    "referer_not_found": "Referrer not found",
                    "referral_email_used": "Referral email already used",
                    "referral_number_used": "Referral number already used",
                    "registration_title": "Registration",
                    "first_name_placeholder": "First Name",
                    "last_name_placeholder": "Last Name",
                    "email_placeholder": "Email Address",
                    "mobile": "Mobile",
                    "confirm_password": "Confirm Password",
                    "referral_id_placeholder": "Referral ID (optional)",
                    "register_button": "Register",
                    "customer": "Customer",
                    "driver": "Driver",
                    "confirm_password_not_match_err": "Passwords do not match",
                    "password_must_not_contain_whitespaces": "Password must not contain whitespaces",
                    "password_must_have_at_least_one_uppercase_character": "Password must have at least one uppercase character",
                    "password_must_have_at_least_one_lowercase_character": "Password must have at least one lowercase character",
                    "password_must_contain_at_least_one_digit": "Password must contain at least one digit",
                    "proper_input_name": "Please enter a valid name",
                    "select_language": "Select Language"
                }
            }
        ];
        
        dispatch({
            type: FETCH_LANGUAGE_SUCCESS,
            payload: {
                defaultLanguage: defaultLanguages[0].keyValuePairs,
                langlist: defaultLanguages
            }
        });
    }, 3000); // 3 second timeout
    
    onValue(languagesRef, snapshot => {
        clearTimeout(timeoutId); // Cancel timeout if Firebase responds
        console.log("Languages: onValue callback triggered, snapshot exists:", !!snapshot);
        console.log("Languages: snapshot.val() exists:", !!snapshot.val());
        if (snapshot.val()) {
            console.log("Languages: Processing language data...");
            const data = snapshot.val();
            let defLang = null;
            const arr = Object.keys(data).map(i => {
                data[i].id = i;
                if(data[i].default){
                    defLang = data[i].keyValuePairs;
                }
                return data[i]
            });
            console.log("Languages: Dispatching FETCH_LANGUAGE_SUCCESS with", arr.length, "languages");
            dispatch({
                type: FETCH_LANGUAGE_SUCCESS,
                payload: {
                    defaultLanguage: defLang,
                    langlist: arr
                }
            });
        } else {
            console.log("Languages: No data in snapshot, dispatching FAILED");
            dispatch({
                type: FETCH_LANGUAGE_FAILED,
                payload: "No Languages available."
            });
        }
    });
};

export const editLanguage = (lang, method) => (dispatch) => {
    const {
        languagesRef,
        languagesEditRef
    } = firebase;
    dispatch({
        type: EDIT_LANGUAGE,
        payload: { lang, method }
    });
    if (method === 'Add') {
        push(languagesRef, lang);
    } else if (method === 'Delete') {
        remove(languagesEditRef(lang.id));
    } else {
        set(languagesEditRef(lang.id),lang);
    }
}


export const convertLanguage = async (word, userLangLocale)=>{
    const {
        languagesRef,
        langEditRef,
        config,
    } = firebase;
    
    let langKey = getLangKey(word);

    onValue(languagesRef, async (snapshot) => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const langLocaleArr = Object.keys(data).map(i => {
                data[i].id = i;
                return {langLocale : data[i].langLocale, id: data[i].id}
            });

            let defLangLocale = "";

            if(userLangLocale){
                defLangLocale = userLangLocale;
            }else{
                const defLocale = Object.keys(data).filter(i => {
                    data[i].id = i;
                    return data[i].default === true;
                })[0];

                defLangLocale = data[defLocale].langLocale;
            }

            for (let j = 0; j < langLocaleArr.length; j++){
                try{
                    if(langLocaleArr[j].langLocale === defLangLocale){
                        update(langEditRef(langLocaleArr[j].id),{[langKey]:word})
                    }else{
                        const response = await fetch(`https://europe-west1-${config.projectId}.cloudfunctions.net/gettranslation?str=${word}&from=${defLangLocale}&to=${langLocaleArr[j].langLocale}`, {
                            method: 'GET',
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          })
                          const json = await response.json();
                          if(json){
                            update(langEditRef(langLocaleArr[j].id),{[langKey]:json.text})
                          }
                    }
                  }
                  catch(err) {
                    console.log("errror occured in language add", err)
                  };
            }
        }
    }, {onlyOnce: true});

}